<template>
  <!-- 下拉刷新中的元素即使是绝对定位也会收到transform属性的影响，所以把绝对定位的元素放在外面 -->
  <div class="wrapper" ref="wrapper" >
    <pulldown-page class="home" background="#F7F7F7" :refresh="onRefresh" :is-scroll="true" color="#333333">
      <div class="header" v-if="!svipMark">
        <div class="header-wrapper">
          <div class="header-wrapper-title">
            <span class="">天美贷</span>
            <!-- 未登录时 -->
            <div class="login-btn" v-if="creditStatus === 'UN_LOGIN'" @click="goLogin"><span>登录/注册</span></div>
          </div>
        </div>
        <p class="header-wrapper-content">合规低息的信贷服务</p>
      </div>
      <div v-else class="header">
        <div class="guang"></div>
        <div class="svipMark">
          <div class="svipMark-left">{{svipMark.leftContent||''}}</div>
          <span class="svipMark-center">{{svipMark.centerContent||''}}</span>
          <span @click="jumpWithdraw" class="svipMark-right">{{svipMark.rightContent||''}}</span>
        </div>
      </div>

      <section class="content" ref="content">
        <!-- 系统维护中 -->
        <div class="system-maintain" v-if="creditStatus === 'SERVER_OFF_LINE'">
          <img src="./images/system.png" />
          <div>系统维护中...</div>
        </div>
        <!-- 其他状态 -->
        <template v-else>
          <!-- 至尊卡顶部视图 -->
          <supreme-top
            v-if="topFloatViewVisible"
            :info="topFloatViewInfo"
            @onUpCardTap="upCardJump"
          />
          <auth-tips-top class="auth-tips-top"  :class="{mt0:!topFloatViewVisible}" v-if="authTipsTopVisible" :msg="creditUpdateFloatBean.message"></auth-tips-top>
          <div class="card-container"  >
            <van-swipe class="card-swipe" :show-indicators="loanConfigList.length>0" :duration="500" :loop="true" :autoplay="5000">
              <template v-if="hasOverdueAmount">
                <van-swipe-item>
                  <!-- 逾期banner -->
                  <overdue-banner
                    :amount="quotaInfo.overdueAmount"
                    @onRepay="goRepayment"
                    @onCheckAccount="checkAccount"
                  />
                </van-swipe-item>
              </template>
              <template v-else-if="passIndexCardInfo.showPassCard === 'Y'">
                <van-swipe-item>
                  <pass-card-swipe-item
                    :passIndexCardInfo="passIndexCardInfo"
                    @withdrawAction="goWithdraw"
                  />
                </van-swipe-item>
              </template>
              <template v-else>
                <!-- 导流卡片 -->
                <van-swipe-item v-for="(item,index) in loanConfigList" :key="index">
                  <div class="loan-card">
                    <div class="loan-card-header">
                      <div class="loan-card-title">{{item.productName}}</div>
                      <img src="./images/img_top_notice.png">
                    </div>
                    <!-- <p class="txt">可用额度(元)</p> -->
                    <p class="txt">{{item.displayInfo.title}}</p>
                    <div class="amount">
                      {{ item.displayInfo.amount | currency }}
                    </div>
                    <p class="total">{{item.displayInfo.totalTitle}} {{ item.displayInfo.total}}</p>
                    <p>综合年化（单利计算）{{ item.minPrice }}%-{{ item.maxPrice }}%</p>
                    <div class="bottom-control">
                      <nd-button
                        :class="['btn', {single: !(item.withdrawalJump && item.repaymentJump)}]"
                        @click="apiProductWithdraw(item)"
                        v-if="item.withdrawalJump"
                      >去提现
                      </nd-button>
                      <nd-button
                        :class="['btn', 'outlined', {single: !(item.withdrawalJump && item.repaymentJump)}]"
                        v-if="item.repaymentJump"
                        @click="apiProductRepayAction(item)"
                      >去还款</nd-button>
                    </div>
                  </div>
                </van-swipe-item>
                <van-swipe-item>
                  <div class="card" @click="cardClick" data-sensors-click>
                    <!-- 可借金额，所有状态通用，文案显示有区别 -->
                    <template v-if="quotaInfo.showAuditButton ==='Y'">
                      <img src="./images/icon_loan_waiting_review.png" class="passcard-loan-waiting-img">
                      <div class="passcard-loan-waiting-text">您有一笔借款审核中</div>
                    </template>
                    <template v-else>
                      <img 
                        :src="floatInfo.limitRateFloatBean.url" 
                        class="inc-amt-ad" 
                        @click="goWithdraw"
                        v-if="floatInfo && floatInfo.limitRateFloatBean && floatInfo.limitRateFloatBean.url"
                        data-sensors-exposure-event-name="Element_Exposure"  
                        :data-sensors-exposure-property-caseId="floatInfo.limitRateFloatBean.limitRateType"
                      >
                      <div class="card-amount">
                        <div
                          class="animation-wrapper"
                          :class="upTagAnimationType"
                          v-if="upTagAnimationType"
                          @click="upCardJump"
                          data-sensors-exposure-property-caseId="UP_CARD"
                          data-sensors-exposure-event-name="Element_Exposure"
                        />
                        <span class="text">{{
                          [
                            'CREDIT_SUCCESS',
                            'LOAN_INFO',
                            'LOAN_REFUSED',
                          ].includes(creditStatus)
                            ? '当期可借'
                            : '额度高达'
                        }}(元)</span>
                        <div class="amount">
                          {{ creditLimit | currency }}
                        </div>
                      </div>
                      <!-- 授信通过且未提现过，显示额度有效期 -->
                      <!-- 授信通过_未提现过_提现封禁中 -->
                      <p class="failure-time" v-if="
                        failureTime &&
                          [
                            'CREDIT_SUCCESS',
                            'LOAN_REFUSED'
                          ].includes(creditStatus) &&
                          (!loanList || !loanList.length)
                      "
                      >
                        有效期至{{ failureTime | date('YYYY/MM/DD') }}
                      </p>
                      <!-- 产品名，所有状态通用 -->
                      <div class="card-title" v-else-if="!['CREDIT_REVIEW','LOAN_REFUSED', 'CREDIT_REFUSED'].includes(creditStatus)" :class="['LOAN_INFO','CREDIT_REFUSED','CREDIT_SUCCESS'].includes(creditStatus)&&'mt30'">
                        <!-- <span>天美贷</span> -->
                        <i>
                          <span>综合年化利率12%-24%（单利计算）</span>
                        </i>
                      </div>
                      <!-- 未登录状态 -->
                      <nd-button class="btn repayment" v-if="creditStatus === 'UN_LOGIN'" >立即借款</nd-button>
                      <!-- 授信失败 -->
                      <nd-button class="btn repayment" v-if="creditStatus === 'CREDIT_ERROR'" >立即借款</nd-button>

                      <!-- 授信审核中 -->
                      <div class="card-description" v-if="creditStatus === 'CREDIT_REVIEW'">
                        <p>下拉刷新结果</p>
                      </div>

                      <!-- 授信拒绝 -->
                      <div class="card-description mt40" v-if="creditStatus === 'CREDIT_REFUSED'">
                        <p>&nbsp;</p>
                      </div>

                      <!-- 授信成功 -->
                      <div class="card-description-special" v-if="
                        [
                          'CREDIT_SUCCESS',
                          'LOAN_INFO',
                          'LOAN_REFUSED',
                        ].includes(creditStatus)
                      " :class="dealSpecial(creditStatus)"
                      >
                        <div :class="['CREDIT_SUCCESS','LOAN_INFO'].includes(creditStatus)&&'mt60'">
                          <p>总额度(元) {{ totalLimit | currency }}</p>
                          <p class="loan-refuesed" v-if="creditStatus === 'LOAN_REFUSED' && isOverdueRisk">{{ lockingDay | date }} 可重新获取额度</p>
                          <p class="loan-refuesed" v-else-if="creditStatus === 'LOAN_REFUSED'">您的提现结果已出，获得提额机会</p>
                        </div>
                      </div>
                    </template>
                    <div class="btn-group">
                      <!-- 未授信 -->
                      <nd-button class="btn card-btn" v-if="creditStatus === 'UNCREDIT'">{{ creditText }}</nd-button>

                      <!-- 授信过期 -->
                      <nd-button class="btn card-btn" v-if="creditStatus === 'CREDIT_EXPIRE'">{{ creditText }}</nd-button>

                      <!-- 授信审核中 -->
                      <nd-button class="btn card-btn" v-if="creditStatus === 'CREDIT_REVIEW'" :loading="!quotaInfo.creditQueue" >授信申请审核中</nd-button>

                      <!-- 授信未通过 -->
                      <nd-button class="btn card-btn" v-if="creditStatus === 'CREDIT_REFUSED'" >查额度，立即提现</nd-button>

                      <!-- 授信成功/提现中/提现被拒，锁定期 -->
                      <nd-button class="btn card-btn" v-if="
                        [
                          'CREDIT_SUCCESS',
                          'LOAN_INFO',
                        ].includes(creditStatus)
                      "
                      >{{ quotaInfo.showAuditButton ==='Y'? '查看审核进度': '去提现' }}</nd-button>

                      <!-- 提现拒绝跳提现结果页 -->
                      <nd-button class="btn card-btn" v-else-if="
                        [
                          'LOAN_REFUSED',
                        ].includes(creditStatus)
                      " 
                      >{{quotaInfo.showAuditButton ==='Y'? '查看审核进度': '一键提额'}}</nd-button>
                      <!-- <nd-button class="btn repayment" v-if="
                        [
                          'CREDIT_SUCCESS',
                          'LOAN_INFO',
                          'LOAN_REFUSED',
                        ].includes(creditStatus)
                      " @click="goRepayment" v-stat="{ id: 10073 }"
                      >去还款
                        <img src="./images/img_yuqi.png" v-if="isOverdue" />
                      </nd-button> -->
                    </div>
                    <card-temporary-limit 
                      :limit="floatInfo.bizLimitUpFloatBean.limitUpAmt"  @click.native="goWithdraw"
                      v-if="floatInfo && floatInfo.bizLimitUpFloatBean && floatInfo.bizLimitUpFloatBean.limitUpAmt"
                      data-sensors-exposure-event-name="Element_Exposure"  
                      data-sensors-exposure-property-caseId="limitUp"
                    />
                  </div>
                </van-swipe-item>
              </template>
            </van-swipe>
          </div>
          <append-area :creditStatus="creditStatus" :showPassCard="passIndexCardInfo.showPassCard" :passIndexCardInfo="passIndexCardInfo"></append-area>
          <div class="skc-point"> <!-- 这个代码别删除 给至尊王卡浮窗定位的 --></div>
          <passcard-banner v-if="passcardBannerVisible" :info='topFloatViewInfo.passCardInfo' />
          <template v-if="userInfo.hasDiversion">
            <div class="notice-container">
              <NoticeBar left-icon="volume-o" text="温馨提示：本平台不向学生提供金融服务。以下产品为第三方产品，服务由第三方平台提供，谨防诈骗，以任何名义收取费用的都是诈骗，客诉及服务电话：400-010-0008"></NoticeBar>
            </div>
            <quick-list :list="quickList" v-if="quickList && quickList.length" :them="{width:'1.28rem',height:'1.506667rem'}" position="river_diversion_home_icon"></quick-list>
          </template>
          <template v-else>
            <!-- banner 24/3/21更新为v2接口 不再展示默认banner -->
            <template v-if="bannerList.length > 0">
              <van-swipe v-if="bannerList.length > 0" class="banner" :duration="500" :loop="true" :autoplay="5000" @change="onBannerChange">
                <van-swipe-item v-for="(item, index) in bannerList" :key="index" @click="
                  jumpOutLink(item.jumpUrl, item.activeType, item.caseId)
                "
                >
                  <div class="banner-box">
                    <!-- 针对两个活动单独填充时间 -->
                    <div class="action-box"  v-if="item.activeType === 'ACTIVE_BOX'">
                      <p>{{item.activeTime| formateDate('YYYY年MM月') }}</p>
                      <b>{{item.activeTime| formateDate('DD') }}</b>
                    </div>
                    <img
                      :src="item.imgUrl"
                      :alt="item.caseId"
                      data-sensors-click
                      :data-sensors-exposure-property-caseId="item.caseId"
                      data-sensors-exposure-event-name="Element_Exposure"
                      class="swiper-banner-img"
                      :class="`caseId-${item.caseId}`"
                    />
                  </div>
                </van-swipe-item>

                <div class="indicator" slot="indicator" v-if="bannerList.length > 1">
                  <div class="indicator-item" :class="{ active: index === activeBanner }" v-for="(item, index) in bannerList" :key="index"></div>
                </div>
              </van-swipe>
            </template>
          </template>
          
          <borrow-list
            status="home"
            type="river_diversion"
            :source="source"
            title="借款推荐"
            :equityList="equityList.length>0"
            :countdownVisible="countdownVisible"
            :overdueFloatViewVisible="!!repaymentFloatBean"
            :fllowAccountViewVisible="yzdSubscribeWechatFloatShow==='Y'"
          />

          <!-- 福利专区 -->
    
          <welfare-section :welfareShowList="welfareShowList" v-if="welfareShowList && welfareShowList.length" @on-redirect="(src)=>{jumpEquity(src)}"/>

          <!-- 新手专区 -->
          <template v-if="beginnerShow && beginnerShow.show === 'Y'">
            <div class="home-title " data-sensors-exposure-property-caseId="NEW_PERSON_AREA"
                 data-sensors-exposure-event-name="Element_Exposure"
            >新手专区</div>
            <img @click="goStrategy " :src="beginnerShow.imageUrl" alt="新手专区" data-sensors-click class="newer constant caseId-NEW_PERSON_AREA" >
          </template>
          <template v-if="aboutShow && aboutShow.show === 'Y'">
            <div class="home-title" :style="{'margin-top':beginnerShow && beginnerShow.show ==='Y'?'0.26rem':'0.8rem'}"
                 data-sensors-exposure-property-caseId="ABOUT_US"
                 data-sensors-exposure-event-name="Element_Exposure"               
            >关于天美贷</div>
            <img :src="aboutShow.imageUrl" class="about-img caseId-ABOUT_US" data-sensors-click @click="jumpEquity({
              url:aboutShow.jumpUrl
            })"
            />
          </template>
  
        
        </template>
        <div class="support"  ></div>

      </section>
    </pulldown-page>
    <!-- 底部逾期浮窗 -->
    <template v-if="!!repaymentFloatBean">
      <overdue-float-view
        :amount="repaymentFloatBean.repaymentAmount"
        :isOverdue="repaymentFloatBean.overdue"
        @onRepay="goRepayment"
        @onCheckAccount="checkAccount"
      />
    </template>
    <template v-else-if="yzdSubscribeWechatFloatShow==='Y'">
      <fllow-tmd-account-float-view/>
    </template>
    <template v-else>
      <count-down v-if="countdownVisible"
                  :countDownInfo="countDownInfo"
                  @didFinished="supremeCountDownFinished"
      />
    </template>
    <!-- 高通资方和预览提现的挽留优惠券倒计时 -->
    <retain-count-down :oldPreviewFloatViewResp="oldPreviewFloatViewResp" v-if="oldPreviewFloatViewResp.caseBizType"></retain-count-down>
    <nd-tabbar />
    <nd-dialog v-model="tipsVisible" class="tips-dialog" :footer="false">
      <div class="tips-content">
        <div class="header">
          温馨提示
        </div>
        <p class="body">  
          我们非常重视您的隐私及个人信息保护。请您认真阅读<router-link class="highlight" to="/tmd/protocol/login">《天美贷用户注册及服务协议》</router-link>
          <a class="highlight" @click="routerToProtocol('/protocol/h5/privacy')">《天美贷隐私政策》</a>全部条款，同意并接受全部条款后再开始使用我们的服务。
        </p>
        <nd-button class="footer" @click="agree">
          确定同意，进入天美贷 {{ COUNT_DOWN }}S
        </nd-button>
      </div>
    </nd-dialog>
    <nd-dialog v-model="creditDialog" class="credit-dialog" :closeBtn="true" @close="closeCreditDialog(true)">
      <div class="header"><span>天美贷</span>合规低息的信贷服务</div>
      <div class="body">
        <img src="./images/img_left.png" srcset=" ./images/img_left@2x.png 2x, ./images/img_left@3x.png 3x " />
        <img src="./images/img_right.png" srcset=" ./images/img_right@2x.png 2x, ./images/img_right@3x.png 3x " />
      </div>

      <div class="footer" slot="footer">
        <nd-button class="button" @click="goWithdraw"  >立即借款</nd-button>
        <span class="text-button" @click="closeCreditDialog"  >我再看看</span>
      </div>
    </nd-dialog>
    <nd-dialog v-model="withdrawDialog" class="withdraw-dialog" :closeBtn="true" @close="closeWithdrawDialog">
      <div class="header"><span>温馨提示</span></div>
      <div class="body">
        <p>
          天美贷已为您提供
          <span class="limit">{{ creditLimit | currency }}</span>
          借款额度
          <span v-if="failureTime">，额度有效期至：{{ failureTime | date('YYYY/MM/DD') }}
          </span>
        </p>
        <p>
          如有需求，请尽快提现；一次提现成功后，我们将会为您永久保留额度。
        </p>
      </div>

      <div class="footer" slot="footer">
        <nd-button class="button" @click="goWithdraw" v-stat="{ id: 10140 }">立即提现</nd-button>
        <span class="text-button" @click="closeWithdrawDialog">暂无借款需求</span>
      </div>
    </nd-dialog>
    <river-all-dialog :data="riverCaseList" v-if="riverCaseList.length>0&&!tipsVisible" @close="close" />
    <yzd-dialog v-model="yzdDialog" :img="yzdDialogData.icon" :showValue="yzdDialogData.discountValueV2" />
    <!-- 小美王卡 -->
    <skc id="drag" v-if="showSkc && floatInfo.kingFloat && floatInfo.kingFloat.kingFloatTitle" :kingFloatTitle="floatInfo.kingFloat.kingFloatTitle" :kingGoodsCd="floatInfo.kingFloat.kingGoodsCd"></skc>
    <dialog-back v-model="dialogBackVisible"></dialog-back>
    <!-- 财神爷 -->
    <csy
      v-if="['SHOW_GOD_OF_WEALTH_FUTURE_APPLY','SHOW_GOD_OF_WEALTH_APPLY_SUCCESS'].includes(floatInfo.showGodOfWealth) "
      :status="floatInfo.showGodOfWealth"
    />
    <!-- 协议更新Tips -->
    <termsSheet 
      v-model="showTermsSheet" 
      v-if="showTermsSheet"
      :agreements="agreements"
      @on-agree="getCaseList"
      :agreementVersion="agreementVersion"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { Swipe, SwipeItem, NoticeBar } from 'vant'
import { getKey, setKey } from '../../assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'

import RiverAllDialog from './components/river-all-dialog/index.vue'
import BorrowList from './components/borrow-list'
import YzdDialog from './components/yzd-dialog'
import DialogBack from './components/dialog-back'
import supremeTop from './components/supreme-header-top'
 
import countDown from './components/count-down'
import passcardBanner from './components/passcard-banner'
import CountDownTool from '@/assets/CountDownTool.js'
import passCardSwipeItem from './components/pass-card-swipe-item'
import overdueBanner from './components/overdue-banner'
import overdueFloatView from './components/overdue-float-view'
import fllowTmdAccountFloatView from './components/fllow-tmd-account-float-view' // 弹窗管理器
import popMIxins from './popMIxins'

export default {
  name: 'home',
  components: {
    NoticeBar,
    YzdDialog,
    DialogBack,
    supremeTop,
    countDown,
    passcardBanner,
    passCardSwipeItem,
    overdueBanner,
    overdueFloatView,
    fllowTmdAccountFloatView,
    csy: () => import('@/components/nd-csy'),
    skc: () => import('@/components/nd-drag-skc'),
    termsSheet: () => import('@/view/home/components/terms-sheet'),
    'quick-list': () => import('@/components/quick-list'),
    'van-swipe': Swipe,
    'van-swipe-item': SwipeItem,
    'borrow-list': BorrowList,
    'river-all-dialog': RiverAllDialog,
    'auth-tips-top': () => import('./components/auth-tips-top/index.vue'),
    'card-temporary-limit': () => import('./components/card-temporary-limit/index.vue'),
    'welfare-section': () => import('./components/welfare-section/index.vue'),
    'retain-count-down': () => import('./components/retain-count-down/index.vue'),
    'append-area': () => import('./components/append-area')
  },

  customReadyNotify: true,
  mixins: [popMIxins],
  data () {
    return {
      showTermsSheet: false,  
      agreementVersion: '',
      agreements: [],
      showSkc: false,
      floatInfo: {},
      catOut: false,
      memberGoodsCd: '',
      quickList: [],
      dialogBackVisible: false,
      yzdDialog: false,
      yzdDialogData: {},
      yzdType: 'index',
      activeBanner: 0,
      tipsVisible: false,
      COUNT_DOWN: 5,
      timer: null,
      creditDialog: false, // 提醒授信弹窗
      withdrawDialog: false, // 提醒提现弹窗
      allActivity: [], // 所有活动
      nowPopGroup: '', // 是否显示弹窗
      source: window.location.href,
      borrowList: [], // 列表
      pageWidth: document.documentElement.clientWidth,
      loanConfigList: [],
      riverCaseList: [], // 导流弹窗数据
      countDownInfo: null, // 至尊王卡倒计时
      creditUpdateFloatBean: null,
      topFloatViewInfo: {
        kingFloatInfo: null,
        passCardInfo: null,
        upCardInfo: null
      }, // 顶部横幅展示信息
      passIndexCardInfo: {
        showPassCard: 'N',
        passLimitAmount: 0,
        limitExpireShowType: 'LIMIT_EXPIRE',
        expireCountDownTime: 80 * 60 * 60 * 1000
      },
      oldPreviewFloatViewResp: {},
      repaymentFloatBean: null,
      yzdSubscribeWechatFloatShow: 'N'
 
     
    }
  },
  watch: {
    creditStatus (value) {
      this.$report({
        id: 10136,
        args: {
          visible: value ? 1 : 0
        }
      })
    },

    withdrawDialog (value) {
      this.$report({
        id: 10139,
        args: {
          visible: value ? 1 : 0
        }
      })
    }
  },

  computed: {
    ...mapState('user', {
      userInfo: (state) => state.userInfo,
      quotaInfo: (state) => state.quotaInfo,
      /**
       * UN_LOGIN: 未登录
       * UNCREDIT: 未授信
       * CREDIT_REVIEW: 授信审核中
       * CREDIT_REFUSED: 授信拒绝
       * CREDIT_SUCCESS: 授信成功
       * CREDIT_ERROR: 授信失败
       * CREDIT_EXPIRE: 授信过期但是有在途订单
       * SERVER_OFF_LINE: 服务不可用
       * LOAN_INFO: 借款中
       */
      creditStatus: (state) => state.quotaInfo.creditStatus,
      // creditStatus: (state) => 'LOAN_REFUSED',
      creditLimit: (state) => state.quotaInfo.creditLimit,
      lockingDay: (state) => state.quotaInfo.lockingDay,
      isOverdueRisk: (state) => state.quotaInfo.overdueRisk, // 是否逾期风控 来展示文案 是 可提现 还是 可重新获取额度等
      totalLimit: (state) => state.quotaInfo.totalLimit,
      failureTime: (state) => state.quotaInfo.failureTime,
      authStatus: (state) => state.userInfo.authStatus || [],
      loanStatus: (state) => state.quotaInfo.loanStatus,
      relationId: (state) => state.quotaInfo.relationId,
      loanList: (state) => state.quotaInfo.loanList,
      svipMark: (state) => state.quotaInfo.svipMark // 是否展示首页角标
    }),

    ...mapState({
      caseList: (state) =>
        state.caseList.filter((item) => item.showType === 'NORMS'),
      bannerList: (state) => state.caseListV2.bannerShowList || [],
      aboutShow: (state) => state.caseListV2.aboutShow || {},
      beginnerShow: (state) => state.caseListV2.beginnerShow || {},
      welfareShowList: (state) => state.caseListV2.welfareShowList || [],      
      equityList: (state) =>
        state.caseList.filter((item) => item.showType === 'MEMBER')
    }),
    ...mapState('order', {
      orderList: (state) => state.platOrder.orderList
    }),
    authTipsTopVisible () {
      return this.creditUpdateFloatBean
    },
    creditText () {
      return /** 需要提供身份信息 */ !this.authStatus.includes('OCR') ||
        this.authStatus.includes('OCR_EXPIRE')
        ? '看看我能借多少钱'
        : '只差一步，立获5万额度'
    },
    isOverdue () {
      if (!this.orderList || !this.orderList.length) {
        return false
      }
      for (let item of this.orderList) {
        if (item.hasOverdue) {
          return true
        }
      }
      return false
    },
    hasOverdueAmount () {
      const safeStr = this.safeString(this.quotaInfo.overdueAmount)
      return this.isNotEmptyString(safeStr)
    },
    // 判断是否已登陆
    checkUserInfo () {
      let value = true
      const keys = ['mobile', 'token', 'wu']
      if (typeof this.userInfo !== 'object' || this.userInfo === null) { value = false }
      for (let i of keys) {
        if (this.userInfo[i] === (null || '')) {
          value = false
        }
      }
      return value
    },
    tagDesc () {
      const { tagDesc } = this.equityList[0] || {}
      return tagDesc || ''
    },
    topFloatViewVisible () {
      const hasKingCardInfo = this.isNotEmptyString(this.topFloatViewInfo.kingFloatInfo?.kingCardTitle)
      const hasPassCardInfo = this.isNotEmptyString(this.topFloatViewInfo.passCardInfo?.passCardTag)
      const hasUpCardInfo = this.isNotEmptyString(this.topFloatViewInfo.upCardInfo?.upCardTag)
      return hasKingCardInfo || (hasPassCardInfo && this.showStyle === 'A') || hasUpCardInfo
    },
    passcardBannerVisible () {
      return this.isNotEmptyString(this.topFloatViewInfo.passCardInfo?.passCardTag) && this.showStyle === 'B'
    },
    countdownVisible () {
      return this.countDownInfo != null && this.countDownInfo.remainTime > 0
    },
    upTagAnimationType () {
      const upCardTag = this.topFloatViewInfo.upCardInfo?.upCardTag || ''
      if (upCardTag === 'HAVE_QUALIFICATION') {
        return 'up_a'
      } else if (upCardTag === 'HAVE_EFFECTIVE_LIMIT') {
        return 'up_b'
      }
    }
  },
  async mounted () {
    // 清空弹窗缓存的 V3 优惠券  
    sessionStorage.removeItem('couponSerialNoV3')
    this.$nextTick(() => {
      const $wrapper = this.$refs['wrapper']
      $wrapper.addEventListener('scroll', () => {
        this.shitCat()
      })
    })

    if (getKey('FIRST_LOGIN_IN_IOS_H5')) {
      this.tipsVisible = true

      this.countdown()
    }
    window.addEventListener('resize', this.reload)
    // 解决pulldown事件冲突的问题
    this.$refs['content'].addEventListener('touchmove', this.contentTouchMove)

    const channel = getKey('channel') || 'official'

    if (this.isIntervalDay(`${channel}HomePopup`, 1) && this.userInfo.token) {
      const { success, data } = await this.queryPopupX({
        showPlace: 'HOME'
      })
      if (success && data) {
        if (data.popupSwitch) {
          // pushState，并且监听popState事件
          window.history.pushState({}, '', window.location.href)
          window.addEventListener('popstate', () => {
            setKey(`${channel}HomePopup`, Date.now())
            this.dialogBackVisible = true
          })
        }
      }
    }
    this.getFundPageRoute()
  },

  beforeDestroy () {
    window.removeEventListener('resize', this.reload)
    this.$refs['content'].removeEventListener(
      'touchmove',
      this.contentTouchMove
    )

    const $wrapper = this.$refs['wrapper']
    $wrapper.removeEventListener('scroll', this.shitCat)
  },

  async created () {
    await this.getUserInfoX({ forceUpdate: true })
    if (this.userInfo.token) {
      this.getOrderListX({ loanPlatform: 'TMD' })
      this.queryConfigList()      
      this.getPassIndexCardX()
    }
    
    this.termsListUpdate()
    await Promise.all([
      this.getCaseList2(),
      this.getLimit(),
      this.getBorrowListX()
    ])
    this.$bus.$emit('ready')
  },
  beforeRouteLeave (to, from, next) {
    clearInterval(this.timer)
    next()
  },
  methods: {
    shitCat () {
      const $cat = document.getElementById('drag')
      if ($cat) {
        const _left = $cat.style.left
        const _top = $cat.style.top
        if (!this.catOut) {
          this.catOut = true
          $cat.setAttribute(
            'style',
            `left:${_left};top:${_top};transform:translateX(${$cat.offsetLeft > 10 ? '180px' : '-300px'
            })`
          )
        }
        clearTimeout(window.timer)
        window.timer = setTimeout(() => {
          $cat.setAttribute('style', `left:${_left};top:${_top};`)
          this.catOut = false
        }, 100)
      }
    },
    async termsListUpdate () {
      const { success, data } = await this.agreementUpdateX()
      if (success && data) {
        const { agreementVersion, agreements } = data
        this.agreements = agreements || []
        if (agreementVersion && agreementVersion !== localStorage.getItem('agreementVersion')) { 
          this.agreementVersion = agreementVersion
          this.showTermsSheet = true        
          return
        }
        this.getCaseList() 
      }
    },
    ...mapActions('order', ['getOrderListX']),
    ...mapActions(['getCaseListX', 'getCaseList2X']),
    ...mapActions('user', [
      'getLimitX',
      'getUserInfoX',
      'getBorrowList',
      'getBorrowPopX',
      'queryConfigListX',
      'fundPageRoute',
      'getFloatViewInfo',
      'getPassIndexCard',
      'agreementUpdateX'
    ]),

    ...mapActions('authentication', ['creditApplyX']),
    ...mapActions('vip', ['memberInfo']),
    ...mapActions('user', ['getBorrowList', 'queryPopupX', 'getApiProductUrl']),


    async getFundPageRoute () {
      const { success, data } = await this.fundPageRoute()
      if (success && data) {
        const { memberGoodsCd } = data
        this.memberGoodsCd = memberGoodsCd
      }
    },
    async queryConfigList () {
      const { success, data } = await this.queryConfigListX()
      if (success && data) {
        const originalData = data.configs || []
        this.loanConfigList = originalData.map((item) => {
          const displayInfo = this.getAmountDisplayInfo(item)
          item.displayInfo = displayInfo
          return item
        })
      }
    },
    dealSpecial (value) {
      let str = ''
      if (['LOAN_REFUSED'].includes(value)) {
        str = 'mt30'
      }
      return str
    },
    async getBorrowListX () {
      const response = await this.getBorrowList({
        showPlace: 'HOME',
        queryBanner: false,
        version: 'V2'
      })
      if (response.success) {
        const { configs, icons } = response.data
        this.borrowList = configs || []
        this.quickList = icons || []
      }
    },
    /* 获取至尊王卡相关信息
    包括：
    1. 顶部标题
    2. 浮窗信息
    3. 倒计时数据
    */
    async getFloatViewInfoX () {
      const response = await this.getFloatViewInfo({
        showPlace: 'HOME'
      })
      if (response.success) {
        const {
          memberCouponFloat,
          kingFloat,
          passCardFloatBean,
          upCardFloatBean,
          creditUpdateFloatBean,
          oldPreviewFloatViewResp,
          yzdSubscribeWechatFloatShow,
          repaymentFloatBean
        } = response.data

        // 
        // 
        /**
         * 优先级互斥
         * 借款账单已到期||用户逾期 > 老客预览提现优惠> 颜值贷引导关注> 至尊王卡 || pass卡 
         * 逾期: repaymentFloatBean
         * 颜值贷: yzdSubscribeWechatFloatShow
         * 老客倒计时: oldPreviewFloatViewResp
         * pass卡: passCardFloatBean
         * 王卡: memberCouponFloat
         */
        if (repaymentFloatBean?.overdue) {
          this.repaymentFloatBean = repaymentFloatBean
        } else if (oldPreviewFloatViewResp) {
          this.oldPreviewFloatViewResp = oldPreviewFloatViewResp
        } else if (yzdSubscribeWechatFloatShow) {
          this.yzdSubscribeWechatFloatShow = yzdSubscribeWechatFloatShow
        } else {
          this.setCountDownInfo(memberCouponFloat, passCardFloatBean)
        }

        this.topFloatViewInfo.kingFloatInfo = kingFloat || {}
        this.topFloatViewInfo.passCardInfo = passCardFloatBean || {}
        this.topFloatViewInfo.upCardInfo = upCardFloatBean || {}
       
        this.floatInfo = response.data || {}
        this.creditUpdateFloatBean = creditUpdateFloatBean
        this.showStyle = this.topFloatViewInfo.passCardInfo.showStyle
        if (kingFloat && kingFloat.kingGoodsCd) {
          this.$nextTick(() => {
            const $skcTop = document.querySelector('.skc-point')
            if ($skcTop) {
              sessionStorage.setItem(
                'dragPosition',
                JSON.stringify({ top: $skcTop.offsetTop + 'px' })
              )
              this.showSkc = true
            }
          })
        }
      }
    },
    async getPassIndexCardX () {
      const response = await this.getPassIndexCard()
      if (response.success) {
        this.passIndexCardInfo = response.data
      }
    },
    // 设置倒计时信息
    setCountDownInfo (memberCouponFloat, passCardFloatBean) {
      // 点击过关闭按钮，当天不再展示倒计时
      if (!this.isIntervalDay(CountDownTool.Keys.HomeCountDownEndTime, 1)) {
        this.countDownInfo = null
        return
      }
      // pass卡倒计时开关为开，且当天未展示过
      if (passCardFloatBean && passCardFloatBean.homeCountDownSwitch === 'Y') {
        // 获取本地倒计时信息
        const passCardCountDownTime = localStorage.getItem(CountDownTool.Keys.PassCardCountDownTimeStamp)
        const now = Date.now()
        // 判断本地倒计时信息是否存在
        if (passCardCountDownTime) {
          const intTime = parseInt(passCardCountDownTime)
          if (intTime > now) {
            // 本地存在倒计时且倒计时未结束
            // 计算&设置倒计时信息
            const remainTime = intTime - now
            this.countDownInfo = {
              remainTime,
              amount: passCardFloatBean.passLimitAmount,
              countDownType: 'PassCard'
            }
          } else {
            // 倒计时已结束
            setKey(CountDownTool.Keys.HomeCountDownEndTime, Date.now())
          }
        } else {
          this.countDownInfo = null
        }
      } else {
        this.countDownInfo = memberCouponFloat ? {
          remainTime: memberCouponFloat.remainTime * 1000 || 0,
          amount: memberCouponFloat.couponAmount || 0,
          countDownType: 'KingCard'
        } : null
      }
    },
    // 跳转权益卡界面
    jumpEquity (item) {
      if (this.checkUserInfo) {
        if (item.url) {
          // 处理tmd2的链接
          // window.location.href = item.url
          let curUrl = item.url.replace(
            /^http[s]?:\/\/tmd.+?\//,
            `${window.location.origin}/`
          )
          window.location.href = curUrl
        }
      } else {
        this.$router.push('/user/login')
      }
    },
    reload () {
      // 重新渲染
      // location.reload()
    },

    contentTouchMove (event) {
      if (event.currentTarget.scrollTop > 0) {
        event.stopPropagation()
      }
    },

    // 去登录
    goLogin () {
      if (hasNativeMethod('navigateTo')) {
        jsBridge('navigateTo', { path: 'login', exitCurrent: true })
      } else {
        this.$router.push('/user/login')
      }
    },
    // 跳转到提现
    jumpWithdraw () {
      this.$router.push('/withdraw/index')
    },
    // 去提现
    async goWithdraw () {
      // if (this.creditStatus === 'LOAN_REFUSED') {
      //   if (this.passIndexCardInfo.showPassCard !== 'Y') {
      //     this.$message(
      //       `当前账户封禁中，请于${this.formatDate(
      //         this.lockingDay,
      //         'YYYY/MM/DD'
      //       )}再次申请提现`
      //     )
      //   }
      //   return
      // }
      const params = {
        page_status: 'withdraw_click'
      }
      // 卡片提额埋点
      if (this.floatInfo?.limitRateFloatBean?.limitRateType) {
        params.caseid = this.floatInfo.limitRateFloatBean.limitRateType
      }
      // 业务侧埋点
      if (this.floatInfo?.bizLimitUpFloatBean?.limitUpAmt) {
        params.caseid = 'limitUp'
      }

      if (this.floatInfo?.bizLimitUpFloatBean?.limitUpAmt || this.floatInfo?.limitRateFloatBean?.limitRateType) {
        this.$sensors.track('parameters_report', params)
      }

      if (this.creditStatus === 'CREDIT_REVIEW' && !this.quotaInfo.creditQueue) {
        return
      }

      this.$router.push('/middle/limit?flow=H')
    },
    cardClick () {
      this.$sensors.track('index_card_click')
      this.goWithdraw()
    },

    // 去还款
    goRepayment () {
      this.$router.push({
        path: '/repayment',
        query: { type: 'TMD' }
      })
    },

     
    // 新版本的showCase 目前用于获取banner
    async getCaseList2 () {
      await this.getCaseList2X({
        showPlace: 'HOME_PAGE'
      })
    },
    // 获取推荐位
    async getCaseList () {
      if (this.isQlc) return
      const params = {
        loanPlatform: 'TMD',
        step: 'HOME'
      }
      params.firstOpenApp = !sessionStorage.getItem('configDialog') ? 'Y' : 'N'
      const response = await this.getCaseListX(params)
      if (response.success && response.data.length > 0) {
        const data = response.data // data 是一个数组
        // 首页 现在 弹出 的列表
        const popAndHomeArray = data.filter(
          (item) =>
            item.step === 'HOME' &&
            item.showType === 'POPUP' &&
            item.showAction === 'NOW'
        )
        this.dealActivity(popAndHomeArray)
        // 颜值贷导流弹窗逻辑
        const yzdDialogData = data.find(
          (item) => item.activeType === 'YZD_DIVERSION'
        )
        if (yzdDialogData && this.isIntervalDay('yzdDiversion', 1)) {
          this.yzdDialogData = yzdDialogData
          this.yzdDialog = true
          setKey('yzdDiversion', Date.now())
        }
      }
      // 获取浮动活动
      this.getFloatViewInfoX()
    },

    
    async getBorrowPopInfo () {
      const list = []
      if (this.userInfo.token) {
        // 调用导流轮播弹窗接口
        const res = await this.getBorrowPopX({
          showPlace: 'HOME',
          popupType: 'HOME_POPUP'
        })
        const { popups } = res.data || {}

        const homePopup = sessionStorage.getItem('homePopup')

        if (res.success && popups && popups.length > 0 && homePopup !== 'Y') {
          popups.map((item) => {
            list.push({ data: item })
          })
        }
        if (list.length > 0) {
          this.riverCaseList = list
        }
      }
    },
   
    // 关闭导流
    close () {
      this.riverCaseList = []
    },
    
    // 可配置的弹窗
    popupConfigDialog (item) {
      this.allActivity.push({
        data: item,
        mobile: this.userInfo.mobile,
        model: 'config',
        type: Number(item.caseId)
      })
      sessionStorage.setItem('configDialog', new Date().getTime())
    },

    // 获取额度
    getLimit () {
      return this.getLimitX({ loanPlatform: 'TMD' })
    },

    // 获取用户信息
    getUserInfo () {
      // 强制更新，并且无token的时候不发请求
      return this.getUserInfoX({ forceUpdate: true, checkToken: true })
    },
    // 触发刷新
    async onRefresh () {
      this.allActivity = []
      await Promise.all([
        this.getCaseList(),
        this.getLimit(),
        this.getUserInfo()
      ])
      this.getFloatViewInfoX()
      this.getPassIndexCardX()
      return true
    },

    /**
     * 跳转第三方链接
     * 同时解决tmd1跳tmd2等问题
     */
    async jumpOutLink (href, activeId, caseId) {
      if (caseId === 126) {
        // 新人活动跳转
        if (this.checkUserInfo) {
          this.$router.push('/unauthedNewbie/detail')
        } else {
          this.$router.push('/user/login')
        }
      } else if (['XIAOMEI_VIP', 'SVIP'].includes(activeId)) {
        let isVip = 0
        const res = await this.memberInfo()
        if (res.success && res.data) {
          let { memberStatus } = res.data || {}
          isVip = memberStatus === 'NORMAL'
        }
        this.$report({
          id: 10127,
          args: {
            target: activeId,
            step: isVip ? 'vip' : 'novip'
          }
        })
        if (href) {
          let curUrl = href.replace(/^http[s]?:\/\/tmd.+?\//, ``)
          this.$router.push(curUrl)
        }
      } else {
        if (href) {
          let curUrl = href.replace(
            /^http[s]?:\/\/tmd.+?\//,
            `${window.location.origin}/`
          )
          window.location.href = curUrl
        }
      }
    },
    agree () {
      this.tipsVisible = false
      setKey('FIRST_LOGIN_IN_IOS_H5', false)
    },
    countdown () {
      this.timer = setInterval(() => {
        if (this.COUNT_DOWN <= 1) {
          clearInterval(this.timer)
          this.agree()
        } else {
          this.COUNT_DOWN--
        }
      }, 1000)
    },
    onBannerChange (index) {
      this.activeBanner = index
    },
    closeCreditDialog (isCloseBtn) {
      if (isCloseBtn) {
        this.$report({
          id: 10150
        })
      }
      this.creditDialog = false
    },
    closeWithdrawDialog () {
      this.withdrawDialog = false
    },
    goStrategy () {
      this.$router.push('/user/strategy')
    },
 
    // 去授信结果页
    goCreditResult () {
      // 如果是导流用户就去特权卡中间页
      if (this.userInfo.hasDiversion) {
        this.$router.push('/privilege/middle?isHome=T')
      } else {
        this.$router.push(
          `/authentication/result?applyNo=${this.quotaInfo.serialNo}`
        )
      }
    },
    // 去授信提现卡购买引导页面
    handleJumpSpeed () {
      if (this.quotaInfo.creditQueue) {
        this.$router.push(
          `/authentication/wait?applyNo=${this.quotaInfo.serialNo}`
        )
      }
    },
    getAmountDisplayInfo (apiProductItem) {
      const { availableAmount, creditLimit } = apiProductItem || {}
      const hasAvailabelAmount = availableAmount !== null
      const title = hasAvailabelAmount ? '可用额度(元)' : '授信额度(元)'
      const amount = hasAvailabelAmount ? availableAmount : creditLimit
      const totalTitle = hasAvailabelAmount ? '总额度(元)' : ''
      const total = hasAvailabelAmount ? this.formatMoney(creditLimit) : ''
      return { title, amount, totalTitle, total }
    },
    // api产品卡片提现
    apiProductWithdraw (product) {
      this._getApiProductUrl(product, 'LOAN')
    },
    // api产品卡片还款
    apiProductRepayAction (product) {
      this._getApiProductUrl(product, 'REPAY')
    },
    async _getApiProductUrl (product, type) {
      const { success, data } = await this.getApiProductUrl({
        configId: product.configId,
        unionType: type
      })
      if (success && data.url) {
        window.location.href = data.url
      }
    },
    /// 倒计时结束
    supremeCountDownFinished () {
      this.countDownInfo = null
      setKey(CountDownTool.Keys.HomeCountDownEndTime, Date.now())
    },
    upCardJump () {
      if (this.topFloatViewInfo.upCardInfo?.upCardTag === 'HAVE_QUALIFICATION') {
        this.$router.push('/authentication/up/guide')
      } else if (this.topFloatViewInfo.upCardInfo?.upCardTag === 'HAVE_EFFECTIVE_LIMIT') {
        this.$router.push('/withdraw/upcard')
      }
    },
    checkAccount () {
      // 查看扣款账户
      this.$router.push('/bankcard/repay-bank-list')
    }
  }
}
</script>
<style lang="less">
@import "../../assets/less/mixin.less";

.wrapper {
  height: 100%;
  background-color: rgb(247, 247, 247);
}

.home {
  padding-bottom: 80px;
  .support {
    width: 10rem;
    height: 77px;
    background: url('./images/img_icp@2x.png') no-repeat center center;
    background-size: contain;
    margin:90px auto 30px
  }
  @keyframes upCardTagAnimation {
    0% {
      background-position: 0 0;
      opacity: 0.99;
    }
    100% {
      background-position: 100% 0;
      opacity: 1;
    }
  }
  .page {
    background-color: #f7f7f7;
    padding-bottom: 115px;
    height: 100%;
    .mt60 {
      margin-top: -40px;
    }

    .header {
      position: relative;
      width: 750px;
      height: 476px;
      background: url("./images/bg_home@2x.png");
      background-size: cover;

      .svipMark {
        width: 670px;
        height: 102px;
        background: url("./images/bg_svip@2x.png");
        background-size: cover;
        position: absolute;
        top: 140px;
        left: 40px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffdeba;
        line-height: 102px;
        position: relative;

        &-left {
          display: inline-block;
          height: 44px;
          background: #3c353c;
          border-radius: 22px;
          line-height: 44px;
          text-align: center;
          margin-left: 20px;
          padding: 0 14px;
        }

        &-center {
          padding-left: 10px;
        }

        &-right {
          position: absolute;
          right: 20px;
          padding-left: 60px;
        }

        &-right::after {
          content: ">";
          padding-left: 8px;
        }

        .pl8 {
          padding-left: 8px;
        }
      }

      .header-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 89px 40px 0;
        position: relative;

        &-title {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;

          >span {
            height: 65px;
            font-size: 46px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #ffffff;
            line-height: 65px;
            letter-spacing: 4px;
          }
        }

        &-content {
          padding: 0 40px;
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          line-height: 40px;
          letter-spacing: 3px;
        }

        .slogan {
          position: absolute;
          font-size: 22px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: @fc4;
          line-height: 30px;
          letter-spacing: 2px;
          left: 226px;
          bottom: 18px;
        }

        .login-btn {
          width: 180px;
          height: 50px;
          border-radius: 25px;
          border: 1px solid #ffffff;
          text-align: center;
          line-height: 50px;

          >span {
            height: 40px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
          }
        }

        .avatar {
          height: 79px;
        }
      }
    }

    .content {
      overflow-y: auto;
      overflow-x: hidden;
      margin-top: -256px;

      .supreme-header {
        margin: 0 auto;
        margin-bottom: 20px;
        position: relative;
      }

      .system-maintain {
        margin-top: 328px;
        text-align: center;
        font-size: 26px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 36px;
        color: @fc3;

        img {
          width: 408px;
          height: 250px;
        }
      }
      .card-swipe{
        margin-bottom: -30px;
        .van-swipe-item {
          padding-bottom: 50px;
          // height: 460px;
        }
        .van-swipe__indicators {
          bottom:16px;
          .van-swipe__indicator {
            width: 24px;
            height: 6px;
            background: #D0D0D0;
            border-radius: 3px;
            &.van-swipe__indicator--active {
              background: #FF4633;
            }
          }
        }
      }
      .loan-card {
        width: 670px;
        height: 420px;
        background: #ffffff;
        box-shadow: 0px 15px 30px 0px rgba(211, 211, 211, 0.8);
        margin: 0 auto;
        overflow: hidden;
        position: relative;
        text-align: center;
        border-radius: 20px;
        padding: 20px 50px;
        .loan-card-header {
          display: flex;
          align-items: center;
          padding-top: 10px;
          .loan-card-title {
            font-size: 38px;
            line-height: 38px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
          }
          img {
            margin-left: 8px;
          }
          span {
            width: 2px;
            height: 34px;
            background: #333333;
            border-radius: 2px;
            margin: 0 10px
          }
          p {
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
          }
        }
        .exp {
          color: #93C9F7;
          font-size: 20px;
          background: url(./images/icon_tongguoshenhe.png) no-repeat 4px center;
          background-size: 22px 20px;
          padding-left:30px;
          margin-top: 10px;
          text-align: left;
        }
        .txt {
          font-size: 28px;
          margin-top: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333;
        }
        .amount {
          font-size: 70px;
          font-family: DIN-Medium, DIN;
          font-weight: 500;
          padding:10px 5px;
        }
        p {
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 33px;
          margin-top: 7px;
          &.total {
            height: 33px;
          }
        }
        .btn {
          margin: 0 auto;
          width: 460px;
          height: 78px;
        }
        .bottom-control {
          display: flex;
          align-content: center;
          margin-top: 16px;
          .btn {
            width: 270px;
            &.outlined {
              background: #fff;
              color: #FF4633;
              border: 2px solid #FF4633;
            }

            &.single {
              width: 460px;
            }
          }
        }
      }

      .card {
        width: 670px;
        // height: 420px;
        background: #ffffff;
        box-shadow: 0px  15px 30px 0px rgba(211, 211, 211, 0.8);
        margin-left: 40px;
        overflow: hidden;
        position: relative;
        text-align: center;
        border-radius: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding:20px 20px 40px;
        .inc-amt-ad {
          width:630px;
          height:80px;
          margin-bottom: 30px;
        }
        .passcard-loan-waiting-img {
          width: 120px;
          height: 115px;
          margin: 80px auto 0;
        }

        .passcard-loan-waiting-text {
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          margin-top: 25px;
          margin-bottom: 15px;
        }

        .failure-time {
          position: absolute;
          top: 0;
          left: 0;
          // width: 333px;
          padding: 0 30px 0 10px;
          height: 64px;
          line-height: 64px;
          // padding-left: 40px;
          background: url(./images/failure_time_bg.png) center center no-repeat;
          background-size: 100% 100%;
          font-size: 20px;
          color: #ffffff;
        }

        .card-title {
          padding: 0 30px;
          margin-top: 45px;
          line-height: 42px;

          >span {
            height: 33px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 33px;
          }

          i {
            color: @fc4;
            font-style: normal;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            margin-left: 10px;

            .sub-title {
              font-size: 20px;
            }
          }
        }

        .mt30 {
          margin-top: 21px !important;
        }

        .mt65 {
          margin-top: -65px !important;
        }

        .card-amount {
          padding-top: 30px;
          color: #ffffff;
          .text {
            height: 40px;
            font-size: 28px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 40px;
          }

          .amount {
            height: 97px;
            font-size: 80px;
            font-family: DIN-Medium, DIN;
            font-weight: 500;
            color: #333333;
            line-height: 97px;
          }
        }

        .btn {
          width: 460px;
          height: 88px;
          background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
          border-radius: 47px;
          margin: 18px auto 0;
          line-height: 88px;
          text-align: center;

          &__white {
            background: #ffffff;
            color: #ff4633;
          }
        }

        .card-description {
          margin-top: 60px;

          img {
            width: 36px;
            margin-bottom: 8px;
          }

          p {
            font-size: 24px;
            line-height: 30px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: @fc4;
          }
        }

        .mt10 {
          margin-top: 0;
        }

        .mt80 {
          margin-top: 80px !important;
        }

        .card-description-special {
          margin-top: 40px;

          img {
            width: 36px;
            margin-bottom: 8px;
          }

          p {
            font-size: 24px;
            line-height: 33px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: @fc4;
          }

          .loan-refuesed {
            padding-top: 7px;
          }

          .mt40 {
            margin-top: -40px;
          }
        }
      }

      .btn-group {
        display: flex;
        justify-content: space-around;
        align-items: center;
        margin: 0px 40px 0;

        .btn {
          flex: 1;

          &.repayment {
            position: relative;
            background: #fff;
            border: 2px solid #ff4633;
            color: #ff4633;
            margin-left: 30px;

            >img {
              position: absolute;
              right: 0;
              top: -18px;
              width: 100px;
              height: 46px;
            }
          }
        }
      }

      .main-btn {
        margin: 0 auto;
        margin-top: 30px;
      }

      .banner {
        width: 670px;
        height: 340px;
        // background-color: #ffffff;
        margin: 0 auto;
        margin-top: 40px;
        position: relative;
        .banner-box {
          position: relative;
        }
        .action-box {
          position: absolute;
          pointer-events: none;
          padding-left: 30px;
          padding-top: 115px;
          font-family: DIN, DIN;
          color: #FFFFFF;
          width: 100%;
          p {
            font-weight: 500;
            font-size: 28px;
            line-height: 28px;
            width: 180px;
            text-align: center;
          }
          b {
           
            font-weight: 500;
            font-size: 88px;
            line-height: 90px;
            width: 110px;
            display: block;
            text-align: center;
            margin-top: 18px;
          }
        }
        .van-swipe {
          width: 670px;
          height: 340px;
        }
        .van-swipe-item {
          width: 670px;
          height: 340px;
        }

        img {
          width: 100%;
          height: 100%;
        }

        .indicator {
          position: absolute;
          bottom: 8px;
          display: flex;
          flex-direction: row;
          left: 50%;
          transform: translateX(-50%);

          .indicator-item {
            width: 16px;
            height: 4px;
            background-color: #fff;
            opacity: 0.5;
            border-radius: 2px;

            &+.indicator-item {
              margin-left: 14px;
            }

            &.active {
              opacity: 1;
            }
          }
        }
      }

      .equity-icon {
        width: 670px;
        height: 500px;
        border-radius: 20px;
        margin: 30px auto 0;
        padding-top: 26px;

        &-title {
          padding-left: 0px;
          font-size: 38px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
        }
      }

      .equity {
        position: relative;
        width: 670px;
        height: 400px;
        margin: auto;
        margin-top: 20px;

        :nth-child(1){
          position: absolute;
          width: 330px;
          left: 0px;
          top: 0px;
          height: 400px;
        }
        :nth-child(2){
          position: absolute;
          width: 330px;
          right: 0px;
          top: 0px;
          height: 195px;
        }
        :nth-child(3){
          position: absolute;
          width: 330px;
          right: 0px;
          bottom: 0px;
          height: 195px;
        }
      }
      .cell-title {
        margin: 0px 40px;
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        .left {
          font-size: 38px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 53px;
        }

        .right {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 53px;
          display: flex;
          flex-direction: row;

          .look {
            margin-right: 13.5px;
          }

          img {
            margin-top: 20px;
            width: 9px;
            height: 16px;
          }
        }
      }

      .newer {
        margin-top: 23px;
        width: 750px;
        height: 220px;
        box-sizing: content-box;
        // margin-bottom: 15px;
      }

      .recomment-list {
        margin: 0 40px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        flex-wrap: wrap;

        .recomment-item {
          width: 320px;
          height: 140px;
          margin-top: 25px;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .quick-list {
        background: #fff;
        border-radius: 20px;
        margin: 20px 40px auto;
        padding: 14px 0px 16px 0px;
        justify-content: space-around;
        .item {
          margin-top: 14px;
          .text {
            font-size: 26px;
            margin-top: 0px;
          }
        }
      }
    }
  }
}
.animation-wrapper {
  width: 117px;
  height: 110px;
  position: absolute;
  top: 20%;
  right: 0px;
  animation: upCardTagAnimation 0.5s steps(14) infinite;
  &.up_a {
    background: url(./images/up_a.png) no-repeat;
    background-size: 1770px 110px;
  }
  &.up_b {
    background: url(./images/up_b.png) no-repeat;
    background-size: 1770px 110px;
  }
}
</style>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.fllow-account{
  position: fixed;
  bottom: 98px;
  margin-bottom: env(safe-area-inset-bottom);
}
.count-down {
  position: fixed;
  bottom: 98px;
  margin-bottom: env(safe-area-inset-bottom);
}
.overdue-float-view {
  position: fixed;
  bottom: 97px;
  margin-bottom: env(safe-area-inset-bottom);
}
.notice-container {
  width: 670px;
  height: 54px;
  background: #fffdf2;
  border-radius: 20px;
  margin: 38px auto 0;
  overflow: hidden;

  /deep/.van-notice-bar {
    font-size: 22px;
    height: 100%;
  }

  /deep/.van-notice-bar__left-icon {
    font-size: 22px;
  }
}
.home-title {
  font-size: 38px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  padding-left: 40px;
  margin-top: 60px;
}
.about-img {
  width: 670px;
  height: 280px;
  margin:20px auto;
  display: block;
}
.constant {
  margin-bottom: env(safe-area-inset-bottom) !important;
  margin-bottom: constant(safe-area-inset-bottom) !important;
}

.wrapper {
  width: 752px;
  overflow-y: auto;
}



.guang {
  position: absolute;
  animation: rotate 1.5s linear infinite;
  width: 250px;
  height: 90px;
  top: 140px;
  background: url("./components/borrow-list/images/guang.png");
  background-size: cover;
  z-index: 2;
}

@keyframes rotate {
  0% {
    left: 0;
  }

  100% {
    left: 480px;
  }
}

.tips-content {
  padding: 20px 50px 70px;

  .header {
    font-size: 42px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 59px;
  }

  .body {
    margin-top: 26px;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 40px;

    .highlight {
      color: #8eb2d8;
    }
  }

  .footer {
    display: block;
    width: 460px;
    height: 80px;
    line-height: 80px;
    margin: 90px auto 0;
  }
}

.credit-dialog {
  .header {
    padding: 0 50px;
    margin-top: 17px;
    font-size: 28px;
    text-align: left;
    color: #666666;
    line-height: 40px;

    >span {
      font-size: 42px;
      font-weight: 600;
      color: #333;
      margin-right: 15px;
    }
  }

  .body {
    padding: 0 50px;
    margin-top: 54px;
    display: flex;
    align-items: flex-end;
    justify-content: flex-start;

    >img:first-child {
      width: 206px;
      height: 202px;
      margin-right: 26px;
    }

    >img:last-child {
      width: 252px;
      height: 180px;
    }
  }

  .footer {
    width: 100%;
    text-align: center;
    margin-top: 56px;
    margin-bottom: 30px;

    .button {
      display: block;
      width: 460px;
      height: 76px;
      line-height: 76px;
      margin: 0 auto;
      margin-bottom: 37px;
    }

    .text-button {
      font-size: 28px;
      text-decoration: underline;
      text-align: left;
      color: #8eb2d8;
    }
  }
}

.withdraw-dialog {
  .header {
    padding: 0 50px;
    margin-top: 17px;
    font-size: 28px;
    text-align: left;
    color: #666666;
    line-height: 40px;

    >span {
      font-size: 42px;
      font-weight: 600;
      color: #333;
      margin-right: 15px;
    }
  }

  .body {
    padding: 0 50px;
    margin-top: 15px;

    >p {
      font-size: 28px;
      text-align: left;
      color: #333333;
      line-height: 40px;

      &:last-child {
        margin-top: 30px;
      }

      .limit {
        font-family: DIN-Medium, DIN;
        font-size: 48px;
        font-weight: 500;
      }
    }
  }

  .footer {
    width: 100%;
    text-align: center;
    margin-top: 56px;
    margin-bottom: 30px;

    .button {
      display: block;
      width: 460px;
      height: 76px;
      line-height: 76px;
      margin: 0 auto;
      margin-bottom: 37px;
    }

    .text-button {
      font-size: 28px;
      text-decoration: underline;
      text-align: left;
      color: #8eb2d8;
    }
  }
}

.passcard-banner {
  margin: 20px auto;
}
</style>
